import functions from './functions.js';
import calendar from  './calendar.js';
import Slider from "./Slider";
import {SimpleGuests} from "./simple-guests.js";
import tplLoader from "./tpl-loader.js";

const $window = $(window);

$(() => {
    details.init();

    details.map();
});

const details = {
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        persons: '2', 
        dates: null,
        dateFrom: null,
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
        numberOfPets: null,
        optionals: null,
        focusOnBooking: false,
    },
    init() {

        if(! $('.page-type-details')[0]) {
            return;
        }

        // if($('#booking')[0]) {
            $(window).scroll(e => {
                // const offset = $('#booking').offset().top - $('#booking').outerHeight();
    
                $(window).scrollTop() > 600 
                    ? $('.nav-top').addClass('visible') 
                    : $('.nav-top').removeClass('visible');
                
                if(functions.isMobile())
                {
                    var elementTop = $('#select2-guests-container, .selection-text').eq(0).offset().top;
                    var elementBottom = elementTop + $('#select2-guests-container, .selection-text').eq(0).outerHeight();

                    var bookTop = $('.btn-booking, .btn-request').eq(0).offset().top;
                    var bookBottom = bookTop + $('.btn-booking, .btn-request').eq(0).outerHeight();
                    var offset = bookBottom - elementBottom + 5;

                    var viewportTop = $(window).scrollTop();
                    var viewportBottom = viewportTop + $(window).height();

                    if (elementBottom > viewportTop - offset && elementTop < viewportBottom)
                    {
                        $('.nav-bottom').removeClass('visible');                        
                    }
                    else 
                    {     
                        $('.nav-bottom').addClass('visible');
                    }
                }
    
            });
        // }

        $('.btn-booking').on('click', e => {
            const $target = $(e.currentTarget);
            // const unitId = $target.attr('data-unitid');
    
            let $alert = $('.dates-alert');

            if( ! this.params.dateFrom || ! this.params.dateTo) 
            {
                e.preventDefault();
                $alert.addClass('active');
                
                setTimeout(() => {
                    $alert.removeClass('active');
                }, 2500);
            }
        });

        let unitCardSlider = [];
        $('[id^=unit-card-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
            unitCardSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                slidesPerView: 1,
                spacing: 0,
                pager: false
            });
        });

        //modalUnit
        $('[id^=modalUnit]').on('shown.bs.modal', e => {
            let unitModalSlider = [];
            $('[id^=unit-modal-slider]').each((i, elem) => {
                const length = $(elem).find('.keen-slider__slide').length;
                unitModalSlider[i] = new Slider('#' + $(elem).attr('id'), {
                    rubberband: false,
                    loop: true,
                    arrows: true,
                    slidesPerView: 1,
                    spacing: 0,
                    pager: false
                });
            });
        });

        $('.icons-wrapper .share-icon').on('click', function(e) {
            e.preventDefault();        
    
            var translations = {
                en: 'Check out this beautiful villa',
                it: "Dai un'occhiata a questa bellissima villa",
                de: "Schauen Sie sich diese schöne Villa an",
                hr: "Pogledaj ovu prekrasnu vilu"
            };
            var villaTitle = $(this).parents('.page').find('h1').text() ? 
                            $(this).parents('.page').find('h1').text() : 
                            $('head').find('meta[property="og:title"]').attr('content');
    
                            
            var villaLink = encodeURIComponent(villaTitle) + ' ( ' + location.origin + location.pathname + ' )';
            villaTitle = encodeURIComponent(villaTitle);
    
            var service = $(this).attr('id');
    
            if (service == 'email') {
                var subject = translations[functions.getLang()];
                var subjectEncoded = encodeURIComponent(subject);
                location.href = "mailto:?subject=" + subjectEncoded + "&body=" + villaLink;
            }
            else if (service == 'messenger') {
                window.open('fb-messenger://share?link=' + encodeURIComponent(location.origin + location.pathname));
            }
            else if (service == 'viber') {
                window.open('viber://forward?text="' + villaTitle + ' ' + encodeURIComponent(location.origin + location.pathname) + '"');
            }
            else if (service == 'whatsapp') {
                window.open("whatsapp://send?text="+ villaLink);
            }
            else if (service == 'facebook') {
                window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(location.origin + location.pathname), "pop", "width=600, height=400, scrollbars=no")
            }
    
            // $('.item-title-share-all').toggleClass('d-none d-flex');
        });





        details.getParams();

        details.params.objectGroupId = $('#booking').attr('data-objectgroupid');
        details.params.objectId = $('#booking').attr('data-objectid');
        details.params.unitId = $('#booking').attr('data-unitid');

        //details.splitCalendarDates($('[name=dates]').val());

        details.calcErrorMessages = $('#booking').attr('data-calcErrorMessages') ? JSON.parse($('#booking').attr('data-calcErrorMessages')) : null;

        if($('[data-calendarconfig]')[0]) {
            details.calendarInit();
        }
        if(details.params.dateFrom && details.params.dateTo) {
            $('[name="dates"]').each( (index, item) => {

                if($(item)[0]._flatpickr) {
                    $(item)[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
                } else if ($('.datepicker,.datepicker-range')[0]) {
                    $('.datepicker,.datepicker-range')[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
                }
            })
           details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
        }

        details.getCalculation();

        if(details.params.persons && $('[name="persons"]')[0]) {
            $('[name="persons"]')[0].value = details.params.persons;
        }

        $('[name="persons"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            details.params.persons = $target.val();
            functions.setUrlData(details.params, true);
        });

        $('[name="dates"]').on('change', e => {
            e.preventDefault();
            const $target = $(e.target);
            
            if ($target.hasClass('request-dates')) return;
            
            details.splitCalendarDates($target.val());
            functions.setUrlData(details.params, true);

            if(details.params.dateFrom && details.params.dateTo) {
                details.focusOnBooking = true;
            //     $('[name="dates"]').each( (index, item) => {
    
            //         if($(item)[0]._flatpickr) {
            //             $(item)[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            //         } 
            //         else if ($('.datepicker,.datepicker-range')[0]) {
            //             $('.datepicker,.datepicker-range')[0]._flatpickr.setDate([details.params.dateFrom, details.params.dateTo]);
            //         }
            //     })
            //    details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
            }
        });

        $('.btn-clear-dates').on('click', function (e) {
            $('.total-old').addClass('d-none');
            $('.unit-error-container').addClass('d-none');
            $('.book-now-btn').addClass('d-none');
            $('.select-dates-text').removeClass('d-none');
            $('.calculation').addClass('d-none');
            $('.no-calculation').removeClass('d-none');
            $('[name="dates"]')[0]._flatpickr.setDate([]);
            details.params.dateTo = details.params.dateFrom = null;
            functions.setUrlData(details.params, true);
            details.callbackOnDatesSelected(details.params.dateFrom, details.params.dateTo);
        });

        $(window).on('hashchange', e => {
            details.getParams();
            details.getCalculation();
        });

        let $descVideo = $('.description-minigallery').find('iframe');
        if ($descVideo.length) $descVideo.attr('src', $descVideo.attr('src') + '?rel=0');


        details.loadReviews();
        details.inquiryInit();

    },
    loadReviews() {
        $('.reviews-more').on('click', function (e) {
            let $button = $(e.currentTarget);
            let perPage = 3;
            let page = +$button.data('page') + 1;
            let total = Math.round(+$button.data('total') / perPage);
            
            $.post('/services/reviews/', { language : functions.getLang(), perPage : perPage, page: page, objectId: $button.data('objectid') }).then(response => {
                console.log(response);
                if (response.status == true) {
                    $button.data('page', page);
                    if (total <= page) {
                        $button.addClass('d-none');
                    }
                    $(".reviews").append(response.html);
                }
            }).fail(e => {
                console.log(e);
            });
        });
    },
    inquiryInit() {
        $('form#inquiry').on('submit', e => {
            e.preventDefault();

            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            $.each($(e.currentTarget).serializeArray(), function (i, field) {
                params[field.name] = field.value;
            });

            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            grecaptcha.ready(function () {
                grecaptcha.execute('6Ld6Pa8UAAAAADgBzavOEcYA1Jxf6iXp8ueY6jp6', { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {

                        let $formBody = $(".default");

                        response.status ? $('.request-success').removeClass('d-none') : $('.request-error').removeClass('d-none');
                        $formBody.addClass('d-none');

                        setTimeout(() => {
                            $(".request-error, .request-success").addClass('d-none');
                            $formBody.removeClass('d-none');
                            $('.contact-btn').removeClass('d-none');
                            $('.contact-spinner').removeClass('d-flex');
                            $('.contact-spinner').addClass('d-none');
                            $('[data-bs-dismiss="modal"]').click();
                        }, 4000);

                        if (response.status == true) {
                            e.currentTarget.reset();
                        }
                    });
                });
            });
        });
    },

    calendarInit() {
        let config = JSON.parse($('[data-calendarconfig]').attr('data-calendarconfig'));

        let defaultDate = $('[data-calendarconfig][data-defaultdate]').attr('data-defaultdate');
        let minDate = $('[data-calendarconfig]').attr('data-mindate');
        /*if( ! details.params.dateFrom && defaultDate) {
            let dates = defaultDate.split(' - ');
            //details.params.dates = defaultDate;
            details.splitCalendarDates(defaultDate);
            defaultDate = dates[1] ? [dates[0], dates[1]] : (dates[0] ? dates[0] : []);
        }*/

        calendar.calendar.init(
            $('.datepicker-range-book'),
            {
                availabilityMask : config.availabilityMask,
                startDate : config.startDate,
                minStay : config.minStay,
                translations : config.translations,
                defaultDate: defaultDate ? defaultDate : [],
                minDate: minDate ? minDate : 'today',
                mode: 'range',
                inline: true,
                containerClass : 'details-booking-calendar mx-auto',
                showMonths: 4
            },
            details.callbackOnDatesSelected
        );
    },
    callbackOnDatesSelected(from, to) {
        
        $('.calendar-message').removeClass('d-none').text(details.getCalcErrorMessage({type : ! from ? 'selectDates' : 'selectDepartureDate'}));
        if ( to && ! to[1]) {
            // $('.btn-booking').addClass('disabled');
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            details.params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
        details.splitCalendarDates(details.params.dates);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    getCalcErrorMessage(error) {
        if (error && details.calcErrorMessages && details.calcErrorMessages[error.type]) {
            return details.calcErrorMessages[error.type].replace('{$condition}', error.condition);
        }
        return details.calcErrorMessages ? details.calcErrorMessages.general : null;
    },
    getCalculation(unitId = null) {

        //console.log(details.params);

        const dateFrom = details.params.dateFrom;
        const dateTo = details.params.dateTo;
        unitId = details.params.unitId;

        if(
            (details.params.objectId || unitId)
            && details.params.persons
            && dateFrom
            && dateTo
            && details.params.objectGroupId
        ) {

            // let persons = details.params.guests.split(',');
            // $('.guests').text(+persons[0] + +persons[1]);
            let serviceUrl = location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + details.params.objectId)
                + '&persons=' + details.params.persons
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateTo
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang()
                + '&optionals=' + details.params.optionals

                $('.booking-info').prepend(tplLoader).scrollTop(0);
                $('.calc-wrapper').css('opacity', 0);
                $('.calc-wrapper').css('display', 'none');

            return $.getJSON(serviceUrl)
                .done(response => {

                    if(response.status) {
                        const data = response.data || [];
                        
                        Object.entries(data).forEach(unit => {
                            const unitId = unit[0];
                            const unitData = unit[1];

                            const $btnBooking = $('.btn-booking[data-unitid=' + unitId + ']');

                            if(details.isBookable(unitData)) {
                                const unitCalc = unitData.calc;

                                const calcItems = unitCalc.items;
                                let priceOld = 0.00;
                                let priceOldEUR = 0.00;
                                let discountTitle = null;
                                let currencySymbol = unitCalc.currencySymbol;
                                let currencySymbolBefore = unitCalc.currencySymbol != 'kn' ? currencySymbol : '';
                                let currencySymbolAfter = unitCalc.currencySymbol == 'kn' ? currencySymbol : '';

                                calcItems.forEach(item => {
                                    // popust za djecu ne ulazi u prikaz discount cijene
                                    if((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                                        priceOld += item.itemTotal;
                                        priceOldEUR += item.itemTotalEUR;
                                    }
                                    if(item.itemType == 'discount') {
                                        discountTitle = item.itemTitle;
                                        if(item.data && item.data.text) {
                                            discountTitle = item.data.text;
                                        }
                                    }
                                });

                                const total = currencySymbolBefore + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',') + ' ' + currencySymbolAfter;
                                const totalEUR = functions.formatMoney(unitCalc.totalEUR, 0, '.', ',');

                                $('.calc-message').addClass('d-none');
                                $('.unit-price-container').removeClass('d-none');

                                if($btnBooking.attr('href')) {
                                    $btnBooking.attr('href',
                                        $btnBooking.attr('href').split('?')[0] +
                                        '?unitId=' + unitId +
                                        '&dateFrom=' + details.params.dateFrom +
                                        '&dateTo=' + details.params.dateTo +
                                        '&persons=' + details.params.persons +
                                        // '&numberOfPets=' + details.params.numberOfPets +
                                        '&addAllOptionals=' + 1

                                    );
                                }

                                $btnBooking.removeClass('disabled');

                                // Za converted nakon 1.1.2023
                                let $bookingConverted = $('.booking-converted');

                                $('.unit-error-container').addClass('d-none');

                                $('.date-from').text(functions.formatDate(dateFrom, 'dd.mm.yyyy.'));
                                $('.date-to').text(functions.formatDate(dateTo, 'dd.mm.yyyy.'));
                                $('.nights').text(unitCalc.nights);

                                if ($bookingConverted.length)
                                {
                                    $bookingConverted.removeClass('d-none');
                                    $bookingConverted.find('.price-converted').text(functions.formatMoney(unitCalc.total*7.53450, 0, '.', ',') + ' kn');
                                }
                                $('.total').text(total);
                                $('.total-converted').text(totalEUR);


                                if (priceOld != unitCalc.total) {
                                    $('.total-old').removeClass('d-none');
                                    $('.total-old').text(currencySymbolBefore + ' ' + functions.formatMoney(priceOld, 0, '.', ',') + ' ' + currencySymbolAfter);

                                    if ($bookingConverted.length)
                                    {
                                        $bookingConverted.find('.priceOld-converted').text(functions.formatMoney(priceOld*7.53450, 0, '.', ',') + ' kn');
                                    }
                                } else {
                                    $('.total-old').addClass('d-none');
                                }

                                $('.btn-select-dates').addClass('d-none');

                                $('.no-calculation').addClass('d-none');
                                $('.calculation').removeClass('d-none');

                                $('.from-block').addClass('d-none');
                                $('.total-block').removeClass('d-none');

                                $('.select-dates-text').addClass('d-none');
                                $('.book-now-btn').removeClass('d-none');

                                $('.calculation').removeClass('d-none');
                                $('.no-calculation').addClass('d-none');

                            } else {
                                $('.btn-booking').addClass('disabled');
                                $('.unit-error-container').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                                $('.calc-message').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                                $('.unit-price-container').addClass('d-none');

                                $('.no-calculation').removeClass('d-none');
                                $('.no-calculation-select-dates').addClass('d-none');
                                $('.calculation').addClass('d-none');
                                $('.btn-select-dates').removeClass('d-none');

                                $('.total-block').addClass('d-none');
                                $('.from-block').removeClass('d-none');
                            }

                            if(details.focusOnBooking) functions.scrollToElement($('#booking'), 100);
                            setTimeout(() => {
                                let wh = $(window).outerHeight();
                                $('.booking-info').removeClass('loading').find('.list-loader').remove();
                                $('.calc-wrapper').css('opacity', 1);
                                $('.calc-wrapper').css('display', 'flex');
                            }, 600)

                        });
                    }

                }).fail(function (error) {
                    console.log(error);
                });
        }

        else {
            $('.btn-booking').addClass('disabled');
            $('.no-calculation').removeClass('d-none');
            $('.unit-error-container').addClass('d-none');

            $('.calculation').addClass('d-none');
            $('.btn-select-dates').removeClass('d-none');

            $('.calc-message').addClass('d-none');
            $('.unit-price-container').removeClass('d-none');

            $('.total-block').addClass('d-none');
            $('.from-block').removeClass('d-none');
        }
    },
    map() {
        const $map = $('.details-map');
        if ( $map.length ) {
            let map;
            let mapTimeout;
            // check if in viewport
            if ( $map[0].getBoundingClientRect ) {
                $window.on('load, scroll', e => {
                    if ( map ) {
                        return;
                    }
                    clearTimeout(mapTimeout);
                    mapTimeout = setTimeout(() => {
                        let screenHeight = document.documentElement.clientHeight;
                        let mapBounds = $map[0].getBoundingClientRect();
                        if ( screenHeight > mapBounds.top && mapBounds.bottom > 0 ) {
                            window.loadGoogleMaps();
                        }
                    }, 700);
                });
            } else {
                $window.on('load', e => window.loadGoogleMaps());
            }
            // map init
            $window.on('gMapsLoaded', e => {
                let center;
                try {
                    center = JSON.parse($map.attr('data-lat-lng'));
                } catch (e) { }

                if ( center ) {
                    map = new google.maps.Map($map[0], {
                        center: center,
                        zoom: 15
                    });
                    new google.maps.Circle({
                        map: map,
                        center: center,
                        strokeColor: "#2088d0",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#2088d0",
                        fillOpacity: 0.35,
                        radius: 150
                    });
                }
            });
        }
    }
}